import type { CSSProperties } from 'react';
import IButtonProps from '../../interfaces/Button';
import '../styles/Button.css';

function Button({ buttonText, rigthIcon, onClick, size = 'middle', type = 'primary', spacing = 10 } : IButtonProps)
{
	// Brand-Farbe wie bei Map/CardLocation aus sessionStorage (früher via ConfigProvider-Theme).
	const brandColor = sessionStorage.getItem('primaryColor') || '';

	return (
		<button
			type = 'button'
			onClick = {onClick}
			className = {`vcard-btn vcard-btn--${size} vcard-btn--${type}`}
			style = {{ '--vcard-brand': brandColor } as CSSProperties}
		>
			<span className = 'vcard-btn__content' style = {{ gap: `${spacing}px` }}>
				{buttonText}
				{rigthIcon}
			</span>
		</button>
	)
}

export default Button;
